const domain = window.location.hostname;
const isLifecheck = domain.includes('getlifecheck.com');

export const orgName = isLifecheck ? 'Lifecheck' : 'Cova';
export const supportEmail = isLifecheck ? "support@getlifecheck.com" : "support@getcova.com";
export const signupLink = isLifecheck ? "https://app.getlifecheck.com/signup" : "https://app.getcova.com/signup";
export const signinLink = isLifecheck ? "https://app.getlifecheck.com/signin" : "https://app.getcova.com/signin";
export const showLifecheckLogo = isLifecheck;
